export enum DateStepTypeKeys {
  SET_TYPE_SPECIFIC_DATE_FLAG = 'SET_TYPE_SPECIFIC_DATE_FLAG',
  SET_PICKED_DATE = 'SET_PICKED_DATE',
  SET_PICKED_SEATS = 'SET_PICKED_SEATS',
  SET_RETURN_TYPE_SPECIFIC_DATE_FLAG = 'SET_RETURN_TYPE_SPECIFIC_DATE_FLAG',
  SET_RETURN_PICKED_DATE = 'SET_RETURN_PICKED_DATE',
  SET_WEEK_DAYS_LIST_RETURN = 'SET_WEEK_DAYS_LIST_RETURN'
}

export interface ISetTypeSpecificDateFlag {
  type: typeof DateStepTypeKeys.SET_TYPE_SPECIFIC_DATE_FLAG
  payload: boolean
}

export interface ISetPickedDateAction {
  type: typeof DateStepTypeKeys.SET_PICKED_DATE
  payload: Date
}

export interface ISetPickedSeatsAction {
  type: typeof DateStepTypeKeys.SET_PICKED_SEATS
  payload: { seats: number; prmSeats: number }
}

export interface ISetReturnTypeSpecificDateFlag {
  type: typeof DateStepTypeKeys.SET_RETURN_TYPE_SPECIFIC_DATE_FLAG
  payload: boolean
}

export interface ISetReturnPickedDateAction {
  type: typeof DateStepTypeKeys.SET_RETURN_PICKED_DATE
  payload: Date
}

export interface ISetWeekDaysListReturnAction {
  type: typeof DateStepTypeKeys.SET_WEEK_DAYS_LIST_RETURN
  payload: any[]
}

export type DateStepActionTypes =
  | ISetTypeSpecificDateFlag
  | ISetPickedDateAction
  | ISetPickedSeatsAction
  | ISetReturnTypeSpecificDateFlag
  | ISetReturnPickedDateAction
  | ISetWeekDaysListReturnAction
